// extracted by mini-css-extract-plugin
module.exports = {"dateData":"Promotion_dateData__3qleT"};